<template>
    <div class="tab-pane active">
        <PmlProduct :show="showForm" @close="showForm = false"></PmlProduct>
        <div class="modal_content p-15">
            <div class="row">
                <div class="col-md-12 t_right">
                    <button class="btn btn-default" @click.prevent="openForm()">
                        <span class="btn-label">
                            <i class="fa fa-plus-circle"></i>
                        </span>
                        {{ $t('payment_package') }}
                    </button>
                </div>
            </div>
        </div>
        <table class="table table-striped table-bordered m-0">
            <tbody>
                <template v-for="(item, index) in list">
                    <tr>
                        <td class="t_center" colspan="5">
                            <strong>{{ $t('payment_package') }} {{ index+1 }}</strong>
                            <span class="btn btn-xs btn-danger pull-right" v-pml-tooltip="$t('delete')" @click.prevent="destroy(item.id)" v-pml-block="isDeleting"><i class="fa fa-times"></i></span>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('payment_method') }}</th>
                        <th>{{ $t('installments') }}</th>
                        <th>{{ $t('fee') }}</th>
                        <th>{{ $t('installment_value') }}</th>
                        <th>{{ $t('value') }}</th>
                    </tr>
                    <tr v-for="payment in item.items">
                        <td class="t_center">{{ payment.payment_method.display_name }}</td>
                        <td class="t_center">{{ payment.installments }}</td>
                        <td class="t_center">
                            {{ (payment.value + ((payment.fee/100) * payment.value)) - payment.value | pmlFormatCurrencyById(tenant.currency_id) }} ({{ payment.fee }}%)
                            <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                                ({{ ((payment.value + ((payment.fee/100) * payment.value)) - payment.value) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                            </small>
                        </td>
                        <td class="t_center">
                            {{ (payment.value + ((payment.fee/100) * payment.value)) / payment.installments | pmlFormatCurrencyById(tenant.currency_id) }}
                            <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                                ({{ (payment.value + ((payment.fee/100) * payment.value) / payment.installments) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                            </small>
                        </td>
                        <td class="t_center">
                            {{ payment.value + ((payment.fee/100) * payment.value) | pmlFormatCurrencyById(tenant.currency_id) }}
                            <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                                ({{ (payment.value + ((payment.fee/100) * payment.value)) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                            </small>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" class="t_right"><strong>{{ $t('total') }}</strong></td>
                        <td class="t_center">
                            {{  calculateTotal(item.items) | pmlFormatCurrencyById(tenant.currency_id) }}
                            <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                                ({{ calculateTotal(item.items) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                            </small>
                        </td>
                    </tr>
                </template>
                <tr v-show="!list.length">
                    <td class="t_center" colspan="6"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import PmlItem from './Item.vue'
    import PmlProduct from './Form.vue'
    import TableFilters from 'utils/mixins/table-filters'
    import { destroy } from 'services/quotation-payments'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'QuotationPayments',
        mixins: [ TableFilters ],
        components: { PmlItem, PmlProduct },
        data () {
            return {
                showForm: false,
                listConfig: {
                    orderProp: 'id',
                    orderDir: 'asc'
                },
                isDeleting: false
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return this.quotations.find((item) => item.id === parseInt(this.$route.params.quotation)) || {}
            },
            records () {
                return this.quotation.payments || []
            }
        },
        methods: {
            openForm () {
                this.showForm = true
            },
            destroy (id) {
                this.isDeleting = true

                destroy(this.quotation.deal_id, this.quotation.id, id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isDeleting = false })
            },
            calculateTotal (items) {
                return items.reduce((sum, payment) => {
                    return sum + payment.value + ((payment.fee / 100) * payment.value)
                }, 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/payments/Main.vue